// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --bw-text: #13231D;
  --bw-text-secondary: rgba(19, 35, 29, 0.68);
  --bw-text-tertiary: rgba(19, 35, 29, 0.46);
  --bw-primary: #82B194;
  --base-container: 1280px;
  --gutter-desktop: 40px;
  --gutter-tablet: 28px;
  --gutter-mobile: 20px;
  --border-soft: rgba(19, 35, 29, 0.08);
  --border-mid: rgba(19, 35, 29, 0.22);
  --radius-card: 32px;
  --radius-card-sm: 24px;
  --radius-button: 20px;
  --radius-button-header: 18px;
  --shadow-soft: 0 18px 48px rgba(18, 34, 29, 0.04);
}

.VerifyEmailForm_auth-card__uvgqL {
  background: #F7F5F1;
  border: 1px solid rgba(12, 36, 28, 0.08);
  border-radius: 28px;
  padding: 24px 22px 22px;
  box-shadow: 0 14px 40px rgba(16, 25, 21, 0.04);
  width: 100%;
  max-width: 420px;
  font-family: "Sora", system-ui, -apple-system, "Segoe UI", Roboto, Arial, sans-serif;
}
.VerifyEmailForm_auth-card__case__fcT5a {
  display: inline-flex;
  align-items: center;
  min-height: 24px;
  padding: 0 10px;
  border-radius: 999px;
  background: rgba(130, 177, 148, 0.14);
  border: 1px solid rgba(130, 177, 148, 0.24);
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: #5E806C;
}
.VerifyEmailForm_auth-card__title__HwIar {
  margin: 14px 0 6px;
  font-size: 28px;
  line-height: 1.02;
  letter-spacing: -0.03em;
  font-weight: 800;
  color: #13231D;
}
.VerifyEmailForm_auth-card__intro__5xW6T {
  margin: 0 0 18px;
  color: rgba(19, 35, 29, 0.68);
  font-size: 13px;
  line-height: 1.55;
}
.VerifyEmailForm_auth-card__tabs__w1Itv {
  display: grid;
  grid-template-columns: 1fr 1fr;
  border-bottom: 1px solid rgba(16, 25, 21, 0.12);
  margin-bottom: 20px;
}
.VerifyEmailForm_auth-card__tab__BCYN8 {
  padding: 12px 0 13px;
  text-align: center;
  color: rgba(19, 35, 29, 0.68);
  font-size: 13px;
  text-decoration: none;
}
.VerifyEmailForm_auth-card__tab--active__bysk\\+ {
  color: #3D4642;
  font-weight: 700;
  border-bottom: 2px solid #82B194;
  margin-bottom: -1px;
}
.VerifyEmailForm_auth-card__tab--disabled__Rjky5 {
  cursor: not-allowed;
  pointer-events: none;
  opacity: 0.5;
}
.VerifyEmailForm_auth-card__instruction__RLqyN {
  font-size: 13px;
  line-height: 1.55;
  text-align: center;
  color: rgba(19, 35, 29, 0.68);
  margin-bottom: 20px;
}
.VerifyEmailForm_auth-card__code-row__QLsIi {
  display: flex;
  align-items: center;
  gap: 8px;
  justify-content: center;
  margin: 8px 0 24px;
}
.VerifyEmailForm_auth-card__code-box__Gxz5R {
  width: 40px;
  height: 54px;
  border-radius: 12px;
  border: 1px solid rgba(16, 25, 21, 0.12);
  background: #FFFFFF;
  font-size: 18px;
  font-weight: 700;
  color: #2B3732;
  text-align: center;
  outline: none;
  transition: all 0.2s ease;
  box-shadow: 0 1px 0 rgba(255, 255, 255, 0.5) inset;
}
.VerifyEmailForm_auth-card__code-box--filled__z-yB7 {
  border-color: rgba(130, 177, 148, 0.54);
  background: rgba(130, 177, 148, 0.1);
  box-shadow: 0 0 0 3px rgba(130, 177, 148, 0.14);
}
.VerifyEmailForm_auth-card__code-sep__iLLLD {
  width: 10px;
  color: rgba(19, 35, 29, 0.32);
  font-weight: 700;
  text-align: center;
}
.VerifyEmailForm_auth-card__verify-actions__Zf74M {
  display: grid;
  gap: 12px;
  margin-top: 20px;
}
.VerifyEmailForm_auth-card__btn-primary__dUm0b {
  width: 100%;
  min-height: 44px;
  border-radius: 14px;
  background: #82B194;
  color: #fff;
  border: none;
  font-weight: 800;
  font-size: 14px;
  cursor: pointer;
}
.VerifyEmailForm_auth-card__btn-primary__dUm0b:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
.VerifyEmailForm_auth-card__btn-secondary__fwGE1 {
  width: 100%;
  min-height: 44px;
  border-radius: 14px;
  background: #F8F6F2;
  border: 1px solid rgba(16, 25, 21, 0.08);
  color: #8E9894;
  font-weight: 700;
  font-size: 13px;
  cursor: pointer;
}
.VerifyEmailForm_auth-card__btn-secondary__fwGE1:hover:not(:disabled) {
  background: #fff;
  color: #13231D;
}
.VerifyEmailForm_auth-card__link-home__vdx5D {
  display: flex;
  justify-content: center;
  margin-top: 4px;
  font-size: 12px;
  font-weight: 700;
  color: #739F84;
  text-decoration: none;
}
.VerifyEmailForm_auth-card__legal-note__ij\\+4R {
  margin: 18px 0 0;
  text-align: center;
  font-size: 11px;
  line-height: 1.55;
  color: rgba(19, 35, 29, 0.46);
}
.VerifyEmailForm_auth-card__legal-note__ij\\+4R a {
  color: #739F84;
  text-decoration: none;
}
@media (max-width: 480px) {
  .VerifyEmailForm_auth-card__uvgqL {
    padding: 20px 16px;
  }
  .VerifyEmailForm_auth-card__code-row__QLsIi {
    gap: 4px;
  }
  .VerifyEmailForm_auth-card__code-box__Gxz5R {
    width: 36px;
    height: 48px;
    font-size: 16px;
    border-radius: 10px;
  }
  .VerifyEmailForm_auth-card__code-sep__iLLLD {
    width: 6px;
    font-size: 12px;
  }
}
@media (max-width: 320px) {
  .VerifyEmailForm_auth-card__code-box__Gxz5R {
    width: 28px;
    height: 40px;
    font-size: 12px;
  }
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/_variables.scss","webpack://./src/components/VerifyEmailForm/VerifyEmailForm.module.scss"],"names":[],"mappings":"AAyIA;EACI,kBAAA;EACA,2CAAA;EACA,0CAAA;EACA,qBAAA;EAEA,wBAAA;EACA,sBAAA;EACA,qBAAA;EACA,qBAAA;EAGA,qCAAA;EACA,oCAAA;EAEA,mBAAA;EACA,sBAAA;EACA,qBAAA;EACA,4BAAA;EAEA,iDAAA;AC7IJ;;AAdA;EACI,mBDgBmB;ECfnB,wCAAA;EACA,mBAAA;EACA,uBAAA;EACA,8CAAA;EACA,WAAA;EACA,gBAAA;EACA,oFDJQ;ACqBZ;AAfI;EACI,oBAAA;EAAsB,mBAAA;EAAqB,gBAAA;EAAkB,eAAA;EAAiB,oBAAA;EAC9E,qCAAA;EAAuC,2CAAA;EACvC,eAAA;EAAiB,gBAAA;EAAkB,sBAAA;EAAuB,yBAAA;EAA2B,cAAA;AA0B7F;AAvBI;EACI,kBAAA;EAAoB,eAAA;EAAiB,iBAAA;EAAmB,uBAAA;EAAyB,gBAAA;EAAkB,cDKpF;ACyBvB;AA3BI;EACI,gBAAA;EAAkB,6BAAA;EAA+B,eAAA;EAAiB,iBAAA;AAgC1E;AA7BI;EACI,aAAA;EAAe,8BAAA;EAAgC,+CAAA;EAAiD,mBAAA;AAkCxG;AA/BI;EACI,oBAAA;EAAsB,kBAAA;EAAoB,6BAAA;EAA+B,eAAA;EAAiB,qBAAA;AAqClG;AApCQ;EAAY,cAAA;EAAgB,gBAAA;EAAkB,gCAAA;EAAyC,mBAAA;AA0C/F;AAzCQ;EAAc,mBAAA;EAAqB,oBAAA;EAAsB,YAAA;AA8CjE;AA3CI;EACI,eAAA;EAAiB,iBAAA;EAAmB,kBAAA;EAAoB,6BAAA;EAA+B,mBAAA;AAiD/F;AA9CI;EACI,aAAA;EAAe,mBAAA;EAAqB,QAAA;EAAU,uBAAA;EAAyB,kBAAA;AAoD/E;AAjDI;EACI,WAAA;EAAa,YAAA;EAAc,mBAAA;EAAqB,wCAAA;EAChD,mBAAA;EAAqB,eAAA;EAAiB,gBAAA;EAAkB,cAAA;EACxD,kBAAA;EAAoB,aAAA;EAAe,yBAAA;EACnC,kDAAA;AA2DR;AAzDQ;EACI,uCAAA;EACA,oCAAA;EACA,+CAAA;AA2DZ;AAvDI;EACI,WAAA;EAAa,6BAAA;EAA+B,gBAAA;EAAkB,kBAAA;AA4DtE;AAzDI;EACI,aAAA;EAAe,SAAA;EAAW,gBAAA;AA6DlC;AA1DI;EACI,WAAA;EAAa,gBAAA;EAAkB,mBAAA;EAAqB,mBDvDrC;ECwDf,WAAA;EAAa,YAAA;EAAc,gBAAA;EAAkB,eAAA;EAAiB,eAAA;AAmEtE;AAlEQ;EAAa,YAAA;EAAc,mBAAA;AAsEnC;AAnEI;EACI,WAAA;EAAa,gBAAA;EAAkB,mBAAA;EAAqB,mBAAA;EACpD,wCAAA;EAA0C,cAAA;EAAgB,gBAAA;EAAkB,eAAA;EAAiB,eAAA;AA4ErG;AA3EQ;EAAyB,gBAAA;EAAkB,cDlD5B;ACiIvB;AA5EI;EACI,aAAA;EAAe,uBAAA;EAAyB,eAAA;EAAiB,eAAA;EAAiB,gBAAA;EAAkB,cAAA;EAAgB,qBAAA;AAoFpH;AAjFI;EACI,gBAAA;EAAkB,kBAAA;EAAoB,eAAA;EAAiB,iBAAA;EAAmB,6BAAA;AAuFlF;AAtFQ;EAAI,cAAA;EAAgB,qBAAA;AA0F5B;AAvFI;EApFJ;IAqFQ,kBAAA;EA0FN;EAxFM;IACI,QAAA;EA0FV;EAvFM;IACI,WAAA;IACA,YAAA;IACA,eAAA;IACA,mBAAA;EAyFV;EAtFM;IACI,UAAA;IACA,eAAA;EAwFV;AACF;AApFI;EACI;IACI,WAAA;IACA,YAAA;IACA,eAAA;EAsFV;AACF","sourcesContent":["\n// =============================================================================\n// BODHIWELL DESIGN TOKENS\n// =============================================================================\n\n// FONTS\n$font-main: \"Sora\", system-ui, -apple-system, \"Segoe UI\", Roboto, Arial, sans-serif;\n$font-accent: $font-main;\n\n\n// Brand Colors\n$color-primary:        #82B194; // CTA principal, estados activos y acentos del sistema.\n$color-primary-hover:  #739F84;\n$color-primary-active: #678F77;\n$color-gold:           #D6A640;  // Acento complementario para journeys, hitos y estados destacados dentro del dashboard.\n$color-gold-soft:      rgba(214, 166, 64, 0.10);\n\n// Backgrounds & Surfaces\n$color-bg:             #EFF0EC; // Fondo general del sistema y de ejemplos.\n$color-surface:        #F7F5F1; // Superficie oficial para cards, modales y contenedores principales del sistema.\n$color-surface-soft:   #F8F6F2; // Variante suave para interiores, previews, campos y superficies secundarias.\n$color-border:         rgba(16, 25, 21, 0.08); \n\n// Text Colors\n$text-main:            #13231D; // Titulares, labels y acciones principales. Color principal para títulos, cuerpo y acciones prioritarias. \n$text-muted:           #5F726B;\n$text-secondary:       rgba(19,35,29,.68); // Textos de apoyo, descripciones, subtítulos y metadata.\n$text-tertiary:        rgba(19,35,29,.46);  // Footer, placeholders y elementos de menor jerarquía visual.\n\n// Status Colors\n$color-error:          #C95C5C; // Mensajes de validación, borde error y helper error.\n\n\n// Font Sizes\n$font-size-h1:      64px; \n$font-size-h2:      48px; \n$font-size-h3:      24px; \n$font-size-title-mobile: 32px; \n$font-size-body:    16px; \n$font-size-small:   14px; \n$font-size-caption: 13px; \n\n$font-size-section-titles: $font-size-h2; \n$font-size-section-subtitles: $font-size-h3;\n$font-size-section-descripcion: $font-size-body;\n\n$radius-nav:    12px;  // Navegación del manual, tabs suaves y acciones de baja jerarquía.\n$radius-sm:     14px;  // Botones de soporte, badges rectangulares y accesos rápidos.\n$radius-md:     16px;  // Botones principales, inputs, CTA sobre imagen y controles activos.\n$radius-lg:     18px;  // Cards internas, previews, notas y paneles secundarios.\n$radius-xl:     24px;  // Cards principales del manual, modales y contenedores base del sistema.\n$radius-pill:   999px; // Tags de dimensión, chips y elementos totalmente redondeados.\n\n$border-radius: $radius-md;\n$btn-radius:    $radius-pill;\n\n// --- 5. SPACING SCALE ---\n$space-4:  4px;\n$space-8:  8px;\n$space-12: 12px;\n$space-16: 16px;\n$space-24: 24px;\n$space-32: 32px;\n$space-48: 48px;\n\n// --- 6. SHADOWS ---\n$shadow-card: 0 10px 30px rgba(0, 0, 0, 0.03); \n\n$header-height:       64px;\n$sidebar-width-open:  240px;\n$sidebar-width-closed: 80px;\n$submenu-panel-width: 280px;\n\n$transition-speed:    0.3s;\n\n$breakpoint-sm:       576px;\n$breakpoint-md:       768px;\n$breakpoint-lg:       992px;\n$breakpoint-desktop:  1024px;\n\n$base-container:1280px;\n$gutter-desktop:40px;\n$gutter-tablet:28px;\n$gutter-mobile:20px;\n\n$border-soft:rgba(19,35,29,.08);\n$border-mid:rgba(19,35,29,.22);\n\n$radius-card:32px;\n$radius-card-sm:24px;\n$radius-button:20px;\n$radius-button-header:18px;\n\n$shadow-soft:0 18px 48px rgba(18,34,29,.04);\n\n$sidebar-bg:           $color-surface;\n$sidebar-submenu-bg:   #ffffff;\n$sidebar-text-color:   $text-main;\n$sidebar-active-bg:    rgba($color-primary, 0.1);\n$sidebar-active-text:  $color-primary;\n\n\n// Mixins para Tipografía\n@mixin h1 {\n    font-size: 64px;\n    line-height: 1.0;\n    font-weight: 700;\n    letter-spacing: -0.045em;\n}\n\n@mixin h2 {\n    font-size: 48px;\n    line-height: 1.04;\n    font-weight: 800;\n    letter-spacing: -0.035em;\n}\n\n@mixin h3 {\n    font-size: 24px;\n    line-height: 1.28;\n    font-weight: 600;\n    letter-spacing: -0.015em;\n}\n\n@mixin body-text {\n    font-size: 16px;\n    line-height: 1.65;\n    font-weight: 400;\n}\n\n@mixin small-text {\n    font-size: 14px;\n    line-height: 1.5;\n    font-weight: 400;\n}\n\n\n:root {\n    --bw-text: #{$text-main};\n    --bw-text-secondary: #{$text-secondary};\n    --bw-text-tertiary: #{$text-tertiary};\n    --bw-primary: #{$color-primary};\n\n    --base-container: #{$base-container};\n    --gutter-desktop: #{$gutter-desktop};\n    --gutter-tablet: #{$gutter-tablet};\n    --gutter-mobile: #{$gutter-mobile};\n\n\n    --border-soft: #{$border-soft};\n    --border-mid: #{$border-mid};\n\n    --radius-card: #{$radius-card};\n    --radius-card-sm: #{$radius-card-sm};\n    --radius-button: #{$radius-button};\n    --radius-button-header: #{$radius-button-header};\n\n    --shadow-soft: #{$shadow-soft};\n\n}\n\n//Notes\n//El color oficial de card queda formalizado como --bw-card-surface con valor #F7F5F1. \n//Su variante complementaria --bw-card-surface-soft usa #F8F6F2 para superficies internas, previews y contenedores suaves.","@import '../../assets/styles/variables';\n\n.auth-card {\n    background: $color-surface;\n    border: 1px solid rgba(12, 36, 28, 0.08);\n    border-radius: 28px;\n    padding: 24px 22px 22px;\n    box-shadow: 0 14px 40px rgba(16, 25, 21, 0.04);\n    width: 100%;\n    max-width: 420px;\n    font-family: $font-main;\n\n    &__case {\n        display: inline-flex; align-items: center; min-height: 24px; padding: 0 10px; border-radius: 999px;\n        background: rgba(130, 177, 148, 0.14); border: 1px solid rgba(130, 177, 148, 0.24);\n        font-size: 11px; font-weight: 800; letter-spacing: .06em; text-transform: uppercase; color: #5E806C;\n    }\n\n    &__title {\n        margin: 14px 0 6px; font-size: 28px; line-height: 1.02; letter-spacing: -0.03em; font-weight: 800; color: $text-main;\n    }\n\n    &__intro {\n        margin: 0 0 18px; color: rgba(19, 35, 29, 0.68); font-size: 13px; line-height: 1.55;\n    }\n\n    &__tabs {\n        display: grid; grid-template-columns: 1fr 1fr; border-bottom: 1px solid rgba(16, 25, 21, 0.12); margin-bottom: 20px;\n    }\n\n    &__tab {\n        padding: 12px 0 13px; text-align: center; color: rgba(19, 35, 29, 0.68); font-size: 13px; text-decoration: none;\n        &--active { color: #3D4642; font-weight: 700; border-bottom: 2px solid $color-primary; margin-bottom: -1px; }\n        &--disabled { cursor: not-allowed; pointer-events: none; opacity: 0.5; }\n    }\n\n    &__instruction {\n        font-size: 13px; line-height: 1.55; text-align: center; color: rgba(19, 35, 29, 0.68); margin-bottom: 20px;\n    }\n\n    &__code-row {\n        display: flex; align-items: center; gap: 8px; justify-content: center; margin: 8px 0 24px;\n    }\n\n    &__code-box {\n        width: 40px; height: 54px; border-radius: 12px; border: 1px solid rgba(16, 25, 21, 0.12);\n        background: #FFFFFF; font-size: 18px; font-weight: 700; color: #2B3732;\n        text-align: center; outline: none; transition: all 0.2s ease;\n        box-shadow: 0 1px 0 rgba(255, 255, 255, 0.5) inset;\n\n        &--filled {\n            border-color: rgba(130, 177, 148, 0.54);\n            background: rgba(130, 177, 148, 0.10);\n            box-shadow: 0 0 0 3px rgba(130, 177, 148, 0.14);\n        }\n    }\n\n    &__code-sep {\n        width: 10px; color: rgba(19, 35, 29, 0.32); font-weight: 700; text-align: center;\n    }\n\n    &__verify-actions {\n        display: grid; gap: 12px; margin-top: 20px;\n    }\n\n    &__btn-primary {\n        width: 100%; min-height: 44px; border-radius: 14px; background: $color-primary;\n        color: #fff; border: none; font-weight: 800; font-size: 14px; cursor: pointer;\n        &:disabled { opacity: 0.6; cursor: not-allowed; }\n    }\n\n    &__btn-secondary {\n        width: 100%; min-height: 44px; border-radius: 14px; background: #F8F6F2; // --surface-soft\n        border: 1px solid rgba(16, 25, 21, 0.08); color: #8E9894; font-weight: 700; font-size: 13px; cursor: pointer;\n        &:hover:not(:disabled) { background: #fff; color: $text-main; }\n    }\n\n    &__link-home {\n        display: flex; justify-content: center; margin-top: 4px; font-size: 12px; font-weight: 700; color: #739F84; text-decoration: none;\n    }\n\n    &__legal-note {\n        margin: 18px 0 0; text-align: center; font-size: 11px; line-height: 1.55; color: rgba(19, 35, 29, 0.46);\n        a { color: #739F84; text-decoration: none; }\n    }\n\n    @media (max-width: 480px) {\n        padding: 20px 16px;\n\n        &__code-row {\n            gap: 4px;\n        }\n\n        &__code-box {\n            width: 36px;\n            height: 48px;\n            font-size: 16px;\n            border-radius: 10px;\n        }\n\n        &__code-sep {\n            width: 6px;\n            font-size: 12px;\n        }\n    }\n\n\n    @media (max-width: 320px) {\n        &__code-box {\n            width: 28px;\n            height: 40px;\n            font-size: 12px;\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"auth-card": `VerifyEmailForm_auth-card__uvgqL`,
	"auth-card__case": `VerifyEmailForm_auth-card__case__fcT5a`,
	"auth-card__title": `VerifyEmailForm_auth-card__title__HwIar`,
	"auth-card__intro": `VerifyEmailForm_auth-card__intro__5xW6T`,
	"auth-card__tabs": `VerifyEmailForm_auth-card__tabs__w1Itv`,
	"auth-card__tab": `VerifyEmailForm_auth-card__tab__BCYN8`,
	"auth-card__tab--active": `VerifyEmailForm_auth-card__tab--active__bysk+`,
	"auth-card__tab--disabled": `VerifyEmailForm_auth-card__tab--disabled__Rjky5`,
	"auth-card__instruction": `VerifyEmailForm_auth-card__instruction__RLqyN`,
	"auth-card__code-row": `VerifyEmailForm_auth-card__code-row__QLsIi`,
	"auth-card__code-box": `VerifyEmailForm_auth-card__code-box__Gxz5R`,
	"auth-card__code-box--filled": `VerifyEmailForm_auth-card__code-box--filled__z-yB7`,
	"auth-card__code-sep": `VerifyEmailForm_auth-card__code-sep__iLLLD`,
	"auth-card__verify-actions": `VerifyEmailForm_auth-card__verify-actions__Zf74M`,
	"auth-card__btn-primary": `VerifyEmailForm_auth-card__btn-primary__dUm0b`,
	"auth-card__btn-secondary": `VerifyEmailForm_auth-card__btn-secondary__fwGE1`,
	"auth-card__link-home": `VerifyEmailForm_auth-card__link-home__vdx5D`,
	"auth-card__legal-note": `VerifyEmailForm_auth-card__legal-note__ij+4R`
};
export default ___CSS_LOADER_EXPORT___;
